/**
 * FilterPanel.tsx — Organizations V3 (HCO)
 * Filter bar: Universe, Org Type, Show All with Apply / Clear buttons.
 */
import React from 'react';
import { UseFormRegister } from 'react-hook-form';
import styles from '../OrganizationsV3.module.css';
import type { SearchFormValues } from './SearchPanel';
import orgTypes from '../../../lookup/orgTypesSelectListItems';

interface Props {
    register:      UseFormRegister<SearchFormValues>;
    onApply:       () => void;
    onClearFilter: () => void;
    isLoading:     boolean;
}

const universeOptions = [
    { value: '',       label: '— All —' },
    { value: 'MyTer',  label: 'My Territory' },
    { value: 'SPEND',  label: 'Spend' },
    { value: 'INP',    label: 'In-Network Pharmacy' },
    { value: 'CTMS',   label: 'CTMS' },
    { value: 'CRM',    label: 'CRM' },
];

const showAllOptions = [
    { value: 'N', label: 'Active Only' },
    { value: 'Y', label: 'Show All' },
];

export default function FilterPanel({ register, onApply, onClearFilter, isLoading }: Props) {
    return (
        <div className={styles.filterPanel}>

            <div className={styles.searchField}>
                <label className={styles.fieldLabel}>Universe</label>
                <select
                    className={styles.fieldSelect}
                    {...register('universe')}
                    data-testid="field-universe"
                >
                    {universeOptions.map(o => (
                        <option key={o.value} value={o.value}>{o.label}</option>
                    ))}
                </select>
            </div>

            <div className={styles.searchField}>
                <label className={styles.fieldLabel}>Org Type</label>
                <select
                    className={styles.fieldSelect}
                    {...register('orgType')}
                    data-testid="field-orgType"
                    style={{ minWidth: 180 }}
                >
                    <option value="">— All —</option>
                    {orgTypes.map(o => (
                        <option key={o.value} value={o.value}>{o.text}</option>
                    ))}
                </select>
            </div>

            <div className={styles.searchField}>
                <label className={styles.fieldLabel}>Show All</label>
                <select
                    className={styles.fieldSelect}
                    {...register('showAll')}
                    data-testid="field-showAll"
                >
                    {showAllOptions.map(o => (
                        <option key={o.value} value={o.value}>{o.label}</option>
                    ))}
                </select>
            </div>

            <div style={{ display: 'flex', alignItems: 'flex-end', gap: 8, marginLeft: 8 }}>
                <button
                    type="button"
                    onClick={onApply}
                    disabled={isLoading}
                    data-testid="btn-applyFilter"
                    style={{
                        background: '#fff',
                        color: '#3d3e8e',
                        border: '1px solid #fff',
                        borderRadius: 3,
                        padding: '6px 16px',
                        fontWeight: 600,
                        fontSize: 13,
                        cursor: isLoading ? 'not-allowed' : 'pointer',
                        opacity: isLoading ? 0.6 : 1,
                    }}
                >
                    APPLY FILTER
                </button>
                <button
                    type="button"
                    onClick={onClearFilter}
                    disabled={isLoading}
                    data-testid="btn-clearFilter"
                    style={{
                        background: 'transparent',
                        color: '#fff',
                        border: '1px solid #fff',
                        borderRadius: 3,
                        padding: '6px 14px',
                        fontSize: 13,
                        cursor: 'pointer',
                    }}
                >
                    CLEAR FILTER
                </button>
            </div>

        </div>
    );
}
